import styled from 'styled-components'

const MyDiv = styled.div`
.main{
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
    background-color: #F9F9F9;
    border-radius:12px;

}
.col{
    color:rgba(0, 0, 0, 1)
}

`
export default MyDiv
